module.exports = __webpack_public_path__ + "img/title_wrong.e0d74fe5.svg";